import PageHeader from "./PageHeader";
import "./StaticPages.css";


const SuccessPage = () => {
  return (
    <div id="static-page">
      <PageHeader mainHeader="Thank you for your purchase." subHeader="For refunds and queries, please email cody.pham14@gmail.com" />
    </div>  
  )
}

export default SuccessPage;